import { Skeleton, Stack, Typography } from '@mui/material'
import { useGetProjectTags } from '@/service-library/hooks/project-tags'
import { WorkflowStateAction } from '@/types/workflow-state-actions'
import TagChip from '@/components/tags/TagChip'

type AddRemoveProjectTagDisplayProps = {
  action: WorkflowStateAction
}

export default function AddRemoveProjectTagDisplay({
  action,
}: AddRemoveProjectTagDisplayProps) {
  const { projectTags, isPending } = useGetProjectTags({
    filters: {
      id__in: action.params.project_tag_ids.join(),
    },
  })

  const isAddAction = action.action_type?.code === 'add_project_tag'

  return (
    <Stack spacing={1}>
      <Typography variant="body2" color="text.secondary">
        {isAddAction ? 'Add' : 'Remove'}{' '}
        {projectTags.length > 1 ? 'these tags' : 'this tag'}{' '}
        {isAddAction ? 'to' : 'from'} the document:
      </Typography>
      <Stack direction="row" gap={1} flexWrap="wrap">
        {isPending ? (
          <Skeleton variant="rounded" width={50} height={20} />
        ) : (
          projectTags.map((projectTag) => (
            <TagChip key={projectTag.id} tag={projectTag} />
          ))
        )}
      </Stack>
    </Stack>
  )
}
